import {Component} from 'react';

class FloatingBox extends Component {
    render() {
        return (
            <div id="box-animations">
                <ul id="box-area">
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                </ul>
            </div>
        )
    }
}

export default FloatingBox;